import { render, staticRenderFns } from "./FormulariosResultados.vue?vue&type=template&id=579a0bf2&scoped=true"
import script from "./FormulariosResultados.vue?vue&type=script&lang=js"
export * from "./FormulariosResultados.vue?vue&type=script&lang=js"
import style0 from "./FormulariosResultados.vue?vue&type=style&index=0&id=579a0bf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579a0bf2",
  null
  
)

export default component.exports